/*! mfac-presentation-os.js — WRITE theme only. Canvas hides Gallery; YOUR SELECTION sync; Metal→Aluminum display helpers. */
(function () {
  'use strict';

  function productRoot() {
    return (
      document.querySelector('.product-section[data-product-handle]') ||
      document.querySelector('[data-section-type="product"]') ||
      document.querySelector('.product-section') ||
      document
    );
  }

  function isLancePhotoContext(pr) {
    if (!pr) return false;
    if (document.querySelector('[data-mfac-presentation-os]')) return true;
    var tpl = (pr.getAttribute('data-product-template') || '').toLowerCase();
    if (tpl.indexOf('lance-open-edition') !== -1 || tpl.indexOf('open-edition') !== -1) return true;
    var handle = (pr.getAttribute('data-product-handle') || '').toLowerCase();
    // photographic open editions with Presentation option
    var pres = pr.querySelector(
      '.variant-input-wrap[data-handle="presentation"], .variant-input-wrap[name="Presentation"], .variant-input-wrap[data-handle="material"], .variant-input-wrap[name="Material"]'
    );
    return !!pres;
  }

  function selectedValue(pr, handles) {
    for (var i = 0; i < handles.length; i++) {
      var h = handles[i];
      var wrap =
        pr.querySelector('.variant-input-wrap[data-handle="' + h + '"]') ||
        pr.querySelector('.variant-input-wrap[name="' + h + '"]') ||
        pr.querySelector('.variant-input-wrap[data-mfac-option-name="' + h + '"]');
      if (!wrap) continue;
      var checked = wrap.querySelector('input[type="radio"]:checked');
      if (checked) return checked.value || '';
    }
    // fallback: any wrap whose name matches
    var wraps = pr.querySelectorAll('.variant-input-wrap');
    for (var j = 0; j < wraps.length; j++) {
      var name = (wraps[j].getAttribute('name') || wraps[j].getAttribute('data-mfac-option-name') || '').toLowerCase();
      for (var k = 0; k < handles.length; k++) {
        if (name === handles[k].toLowerCase() || name.replace(/\s+/g, '-') === handles[k].toLowerCase()) {
          var c = wraps[j].querySelector('input[type="radio"]:checked');
          if (c) return c.value || '';
        }
      }
    }
    return '';
  }

  function displayPresentation(v) {
    if (!v) return '';
    if (/^metal$/i.test(v)) return 'Aluminum';
    return v;
  }

  function displayFrame(v) {
    if (!v) return '';
    if (/^luxury$/i.test(v) || /^deep$/i.test(v) || /^wide gallery$/i.test(v) || /^wide gallery frame$/i.test(v)) return 'Gallery';
    if (/luxury\s*w/i.test(v) || /deep\s*w/i.test(v) || /gallery\s*\+\s*border/i.test(v) || /wide gallery \+ border/i.test(v) || /gallery w\/ border/i.test(v))
      return 'Gallery + Border';
    if (/^no frame$/i.test(v)) return 'Unframed';
    if (/w\/ border/i.test(v)) return v.replace(/w\/ border/i, '+ Border');
    return v;
  }

  function isGalleryFrame(v) {
    return /gallery/i.test(v || '') || /luxury/i.test(v || '') || /^deep/i.test(v || '');
  }

  function hideInput(el, hide) {
    if (!el) return;
    el.classList.toggle('mfac-pres-hidden', !!hide);
    el.style.display = hide ? 'none' : '';
    var input = el.querySelector('input[type="radio"]');
    if (input) {
      if (hide) {
        input.setAttribute('disabled', 'disabled');
        if (input.checked) input.checked = false;
      } else {
        input.removeAttribute('disabled');
      }
    }
  }

  function frameWrap(pr) {
    return (
      pr.querySelector('.variant-input-wrap[data-handle="frame"]') ||
      pr.querySelector('.variant-input-wrap[name="Frame"]') ||
      pr.querySelector('.variant-input-wrap[data-handle="frame-style"]') ||
      pr.querySelector('.variant-input-wrap[name="Frame Style"]')
    );
  }

  function applyCanvasGalleryGuard(pr) {
    var presentation = selectedValue(pr, ['presentation', 'material', 'Presentation', 'Material']);
    var fw = frameWrap(pr);
    if (!fw) return;
    var canvas = /^canvas$/i.test(presentation);
    fw.querySelectorAll('.variant-input').forEach(function (el) {
      var v = el.getAttribute('data-value') || el.getAttribute('data-mfac-option-value') || '';
      hideInput(el, canvas && isGalleryFrame(v));
    });
    var checked = fw.querySelector('input[type="radio"]:checked');
    var checkedWrap = checked && checked.closest('.variant-input');
    if (canvas && (!checked || (checkedWrap && checkedWrap.classList.contains('mfac-pres-hidden')))) {
      var prefer = Array.prototype.find.call(fw.querySelectorAll('.variant-input'), function (el) {
        if (el.classList.contains('mfac-pres-hidden')) return false;
        var v = el.getAttribute('data-value') || '';
        return /^unframed$/i.test(v) || /^no frame$/i.test(v);
      });
      if (!prefer) {
        prefer = Array.prototype.find.call(fw.querySelectorAll('.variant-input'), function (el) {
          return !el.classList.contains('mfac-pres-hidden');
        });
      }
      if (prefer) {
        var inp = prefer.querySelector('input');
        if (inp) {
          inp.checked = true;
          inp.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }
  }

  function updateSelectionLine(pr) {
    var nodes = document.querySelectorAll('[data-mfac-selection-line]');
    if (!nodes.length) return;
    var presentation = displayPresentation(selectedValue(pr, ['presentation', 'material', 'Presentation', 'Material']));
    var size = selectedValue(pr, ['size', 'image-size', 'Size', 'Image Size']);
    var frame = displayFrame(selectedValue(pr, ['frame', 'frame-style', 'Frame', 'Frame Style']));
    var parts = [];
    if (presentation) parts.push(presentation);
    if (size) parts.push(size);
    if (frame) parts.push(frame);
    var line = parts.length ? parts.join(' · ') : '—';
    nodes.forEach(function (n) {
      n.textContent = line;
    });
    // show/hide relevance panels
    document.querySelectorAll('[data-mfac-pres-panel]').forEach(function (panel) {
      var key = (panel.getAttribute('data-mfac-pres-panel') || '').toLowerCase();
      var show = true;
      if (key === 'acrylic') show = /^acrylic$/i.test(presentation);
      else if (key === 'aluminum' || key === 'metal') show = /^aluminum$/i.test(presentation);
      else if (key === 'canvas') show = /^canvas$/i.test(presentation);
      else if (key === 'gallery') show = /gallery/i.test(frame);
      else if (key === 'border') show = /border/i.test(frame);
      else if (key === 'framed') show = frame && !/^unframed$/i.test(frame) && !/^no frame$/i.test(frame);
      panel.hidden = !show;
      panel.style.display = show ? '' : 'none';
    });
  }

  function boot() {
    var pr = productRoot();
    if (!pr || !isLancePhotoContext(pr)) return;
    pr.setAttribute('data-mfac-pres-os-bound', '1');
    applyCanvasGalleryGuard(pr);
    updateSelectionLine(pr);
    pr.addEventListener(
      'change',
      function (e) {
        if (!e.target || !e.target.matches) return;
        if (e.target.matches('input[data-variant-input], input[type="radio"]')) {
          applyCanvasGalleryGuard(pr);
          updateSelectionLine(pr);
        }
      },
      true
    );
    document.addEventListener('shopify:section:load', function () {
      applyCanvasGalleryGuard(productRoot());
      updateSelectionLine(productRoot());
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
